<p-dialog 
  #unsavedChangesModal 
  id="unsavedChangesModal" 
  class="unsaved-changes-dialog" 
  [(visible)]="dialogVisible" 
  [modal]="true" 
  [header]="confirmationHeader" 
  [responsive]="true" 
  [baseZIndex]="10000" 
  [closable]="false"
  [draggable]="false"
  (onHide)="onDialogHide()">
  
  <div class="modal-content">
    <p class="text-center mb-3">{{confirmationMessage}}</p>
    
    <div *ngIf="isSaving" class="saving-indicator text-center mb-3">
      <i class="pi pi-spin pi-spinner"></i>
      <span class="ml-2">Saving changes...</span>
    </div>
  </div>
  
  <p-footer>
    <button 
      type="button" 
      pButton 
      icon="pi pi-save" 
      label="Save & Continue" 
      (click)="onSaveAndContinue()"
      [disabled]="isSaving"
      class="p-button-success">
    </button>
    
    <button 
      type="button" 
      pButton 
      icon="pi pi-trash" 
      label="Discard & Continue" 
      (click)="onDiscardAndContinue()"
      [disabled]="isSaving"
      class="p-button-warning">
    </button>
    
    <button 
      type="button" 
      pButton 
      icon="pi pi-times" 
      label="Cancel" 
      (click)="onCancel()"
      [disabled]="isSaving"
      class="p-button-secondary">
    </button>
  </p-footer>
</p-dialog>

